// All publicly accesible pages are placed inside the Pages folder which is a special folder that
// we want to exclude from routing
export const pagesSlug = 'pages';

export const isHome = (withSlug: { slug?: string }) => {
  return withSlug.slug === pagesSlug;
};
